import { render, staticRenderFns } from "./RelbaseDocumentsList.vue?vue&type=template&id=54a9dc1d&scoped=true&"
import script from "./RelbaseDocumentsList.vue?vue&type=script&lang=js&"
export * from "./RelbaseDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./RelbaseDocumentsList.vue?vue&type=style&index=0&id=54a9dc1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a9dc1d",
  null
  
)

export default component.exports